package com.exura.features.plandefinition.domain.model.series

enum class SeriesType(val str: String, val spawnType: SeriesSpawnType) {
    SIMPLE_FLOATING("simple_floating", SeriesSpawnType.FLOATING),
    SIMPLE_INSTRUCTION("simple_instruction", SeriesSpawnType.INSTRUCTION),
    SIMPLE_PERSISTENT("simple_persistent", SeriesSpawnType.PERSISTENT),
    SIMPLE_QUESTION("simple_question", SeriesSpawnType.QUESTION),
    UNKNOWN("unknown", SeriesSpawnType.INSTRUCTION);
}
